import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  id: "nav",
  class: "navbar",
  role: "navigation",
  "aria-label": "main navigation"
};
var _hoisted_2 = {
  class: "container"
};
var _hoisted_3 = {
  class: "navbar-brand"
};

var _hoisted_4 = /*#__PURE__*/_createVNode("strong", {
  class: "navbar-item is-large"
}, "tiagoj.co", -1);

var _hoisted_5 = /*#__PURE__*/_createVNode("span", {
  "aria-hidden": "true"
}, null, -1);

var _hoisted_6 = /*#__PURE__*/_createVNode("span", {
  "aria-hidden": "true"
}, null, -1);

var _hoisted_7 = /*#__PURE__*/_createVNode("span", {
  "aria-hidden": "true"
}, null, -1);

var _hoisted_8 = {
  class: "navbar-start"
};

var _hoisted_9 = /*#__PURE__*/_createVNode("span", {
  class: "icon is-large"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-home"
})], -1);

var _hoisted_10 = /*#__PURE__*/_createVNode("span", {
  class: "icon is-large"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-project-diagram is-2"
})], -1);

var _hoisted_11 = /*#__PURE__*/_createVNode("span", {
  class: "icon is-large"
}, [/*#__PURE__*/_createVNode("i", {
  class: "far fa-address-card"
})], -1);

var _hoisted_12 = {
  class: "navbar-end"
};
var _hoisted_13 = {
  class: "navbar-item"
};
var _hoisted_14 = {
  class: "buttons"
};
var _hoisted_15 = {
  class: "control"
};

var _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "en-us", -1);

var _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "pt-br", -1);

var _hoisted_18 = /*#__PURE__*/_createVNode("a", {
  class: "button is-info is-outlined",
  target: "_blank",
  href: "https://twitter.com/intent/tweet?text=Achei bacana isso aqui! https://tiagoj.co"
}, [/*#__PURE__*/_createVNode("span", {
  class: "icon"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fab fa-twitter"
})]), /*#__PURE__*/_createVNode("strong", null, "Tweet")], -1);

export function render(_ctx, _cache) {
  var _component_ImgIcon = _resolveComponent("ImgIcon");

  var _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createBlock("nav", _hoisted_1, [_createVNode("div", _hoisted_2, [_createVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    class: "navbar-item",
    to: {
      path: '/',
      query: {
        locale: _ctx.locale
      }
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_ImgIcon, {
        file: "tiagoj.co-32x32.png",
        alt: "tiagoj.co Billed Cap"
      }), _hoisted_4];
    }),
    _: 1
  }, 8, ["to"]), _createVNode("a", {
    role: "button",
    class: ['navbar-burger', 'burger', {
      'is-active': _ctx.isActive
    }],
    "aria-label": "menu",
    "aria-expanded": "false",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.isActive = !_ctx.isActive;
    })
  }, [_hoisted_5, _hoisted_6, _hoisted_7], 2)]), _createVNode("div", {
    class: ['navbar-menu', {
      'is-active': _ctx.isActive
    }]
  }, [_createVNode("div", _hoisted_8, [_createVNode(_component_router_link, {
    class: "navbar-item",
    to: {
      path: '/',
      query: {
        locale: _ctx.locale
      }
    }
  }, {
    default: _withCtx(function () {
      return [_hoisted_9, _createTextVNode(" " + _toDisplayString(_ctx.t("message.views.home.title")), 1
      /* TEXT */
      )];
    }),
    _: 1
  }, 8, ["to"]), _createVNode(_component_router_link, {
    class: "navbar-item",
    to: {
      path: '/projects',
      query: {
        locale: _ctx.locale
      }
    }
  }, {
    default: _withCtx(function () {
      return [_hoisted_10, _createTextVNode(" " + _toDisplayString(_ctx.t("message.views.projects.title")), 1
      /* TEXT */
      )];
    }),
    _: 1
  }, 8, ["to"]), _createVNode(_component_router_link, {
    class: "navbar-item",
    to: {
      path: '/about',
      query: {
        locale: _ctx.locale
      }
    }
  }, {
    default: _withCtx(function () {
      return [_hoisted_11, _createTextVNode(" " + _toDisplayString(_ctx.t("message.views.about.title")), 1
      /* TEXT */
      )];
    }),
    _: 1
  }, 8, ["to"])]), _createVNode("div", _hoisted_12, [_createVNode("div", _hoisted_13, [_createVNode("div", _hoisted_14, [_createVNode("p", _hoisted_15, [_ctx.locale === 'pt-br' ? _createVNode(_component_router_link, {
    key: 0,
    title: "Change language to English",
    class: "button",
    to: {
      path: _ctx.$route.path,
      query: {
        locale: 'en-us'
      }
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_ImgIcon, {
        file: "flag-en-us-32x32.png",
        alt: "flag-en-us"
      }), _hoisted_16];
    }),
    _: 1
  }, 8, ["to"]) : _createVNode(_component_router_link, {
    key: 1,
    title: "Alterar linguagem para Português",
    class: "button",
    to: {
      path: _ctx.$route.path,
      query: {
        locale: 'pt-br'
      }
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_ImgIcon, {
        file: "flag-pt-br-32x32.png",
        alt: "flag-pt-br"
      }), _hoisted_17];
    }),
    _: 1
  }, 8, ["to"]), _hoisted_18])])])])], 2)])]);
}